/**
 * These are the supported languages defined in our system (Core Data Service).
 * They are used across various components and services.
 */
export enum SupportedLocale {
  Bulgarian = 'bg-BG',
  ChineseTraditional = 'zh-CN',
  Czech = 'cs-CZ',
  Danish = 'da-DK',
  Dutch = 'nl-NL',
  English = 'en-US',
  Estonian = 'et-EE',
  Finnish = 'fi-FI',
  French = 'fr-FR',
  German = 'de-DE',
  Hungarian = 'hu-HU',
  Icelandic = 'is-IS',
  Indonesian = 'id-ID',
  Italian = 'it-IT',
  Japanese = 'ja-JP',
  Korean = 'ko-KR',
  Lithuanian = 'lt-LT',
  Norwegian = 'nn-NO',
  Polish = 'pl-PL',
  Portuguese = 'pt-PT',
  Romanian = 'ro-RO',
  Russian = 'ru-RU',
  Spanish = 'es-ES',
  Swedish = 'sv-SE',
  Turkish = 'tr-TR',
  Thai = 'th-TH',
  Ukrainian = 'uk-UA',
  Vietnamese = 'vi-VN',
}
